import styled from "styled-components";

import img from "../../../public/images/title-section-background.png";
import imgMobile from "../../../public/images/title-section-background-mobile.png";

export const Wrapper = styled.div`
  margin-top: 144px;
  @media (min-width: 1024px) {
    padding: 0 48px;
  }
`;

export const Inner = styled.div`
  text-align: center;
  height: 424px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-image: url(${imgMobile.src});
  background-size: cover;
  background-position-x: center;
  background-position-y: center;
  background-repeat: no-repeat;
  @media (min-width: 768px) {
    background-image: url(${img.src});
    background-size: contain;
  }
`;
